import React from 'react';
import Experiences from '../experiences';

const ExperiencePage = () => <Experiences />;

export default ExperiencePage;
